import React from "react";

class TextField extends React.Component{
    render(){
        const that = this
        return (
            <div class="js-form-field__wrapper">
                <div class="js-form-field__text">
                    <input 
                        type="number" 
                        name={this.props.name}
                        id={this.props.id}
                        min={this.props.min}
                        max={this.props.max}
                        defaultValue={this.props.initial_value}
                        placeholder={this.props.placeholder}
                        required={this.props.required}
                        />
                </div>
            </div>
        )
    }
}

export default TextField